import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { OrderLineRow } from "../sections/OrderLineRow";
import type { OrderLine, ProductOption, Configuration } from "../types";
import type { WorkDetails } from "../../WorkDetailsForm";

interface OrderLinesTabProps {
  orderLines: OrderLine[];
  products: ProductOption[] | undefined;
  configuration: Configuration | null;
  configurationLineId: string | null;
  orderType: "new_work" | "pickup_work" | "field_work";
  editingPrices: Record<string, string>;
  subtotal: number;
  vatAmount: number;
  totalAmount: number;
  onAddLine: () => void;
  onUpdateLine: (id: string, field: keyof OrderLine, value: string | number | boolean | null | Record<string, string> | WorkDetails) => void;
  onSelectProduct: (lineId: string, productId: string) => void;
  onRemoveLine: (id: string) => void;
  onEditingPriceChange: (lineId: string, value: string | undefined) => void;
  getDisplayPrice: (line: OrderLine) => number;
  getAlternativePrice: (line: OrderLine) => { label: string; value: number };
}

export function OrderLinesTab({
  orderLines, products, configuration, configurationLineId, orderType, editingPrices,
  subtotal, vatAmount, totalAmount, onAddLine, onUpdateLine, onSelectProduct,
  onRemoveLine, onEditingPriceChange, getDisplayPrice, getAlternativePrice,
}: OrderLinesTabProps) {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-medium">Tilausrivit</h3>
        <Button type="button" onClick={onAddLine} size="sm"><Plus className="h-4 w-4" />Lisää rivi</Button>
      </div>

      {orderLines.length === 0 ? (
        <p className="text-sm text-muted-foreground text-center py-8">Ei tilausrivejä. Lisää vähintään yksi rivi.</p>
      ) : (
        <div className="space-y-4">
          {orderLines.map((line) => (
            <OrderLineRow
              key={line.id}
              line={line}
              products={products}
              configuration={configuration}
              configurationLineId={configurationLineId}
              orderType={orderType}
              editingPrices={editingPrices}
              onUpdateLine={onUpdateLine}
              onSelectProduct={onSelectProduct}
              onRemoveLine={onRemoveLine}
              onEditingPriceChange={onEditingPriceChange}
              getDisplayPrice={getDisplayPrice}
              getAlternativePrice={getAlternativePrice}
            />
          ))}
          <div className="border-t pt-4 space-y-2">
            <div className="flex justify-between text-sm"><span>Välisumma (ilman ALV):</span><span className="font-medium">{subtotal.toFixed(2)} €</span></div>
            <div className="flex justify-between text-sm"><span>ALV:</span><span className="font-medium">{vatAmount.toFixed(2)} €</span></div>
            <div className="flex justify-between text-lg font-bold"><span>Yhteensä:</span><span>{totalAmount.toFixed(2)} €</span></div>
          </div>
        </div>
      )}
    </div>
  );
}
